import { BrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
import router from "./_setup/router/routes";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dropzone/styles.css";

//import "@mantine/carousel/styles.css";

function App() {
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
